import { Component, EventEmitter, Output } from '@angular/core';
import { Company, CompaniesService, ListArchivedCompaniesParams } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ERROR_COMPANY_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-archived-companies-data',
  templateUrl: './archived-companies-data.component.html',
  styleUrls: ['./archived-companies-data.component.scss'],
})
export class ArchivedCompaniesDataComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  companies?: Company[];
  cursor: string | null = null;
  total?: number;
  filters?: ListArchivedCompaniesParams;

  constructor(private companies_service: CompaniesService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.companies = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listCompanies();
  }

  onRefresh(): void {
    this.companies = [];
    this.cursor = null;
    this.filters = undefined;
    this.total = undefined;
    this.listCompanies();
  }

  onFilter(filters?: ListArchivedCompaniesParams): void {
    this.companies = [];
    this.cursor = null;
    this.filters = filters;
    this.total = undefined;
    this.listCompanies(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listCompanies(this.filters, true);
  }

  listCompanies(filters?: ListArchivedCompaniesParams, is_load_more_running?: boolean): void {
    this.is_list_running = true;
    this.is_load_more_running = is_load_more_running || false;

    const list_companies_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.companies_service.listArchivedCompanies(list_companies_params).subscribe({
      next: response => {
        const companies = response.data.data;
        this.companies = (this.companies ? this.companies : []).concat(companies);
        this.cursor = response.data.cursor;
        if (list_companies_params.cursor == undefined) {
          this.total = response.data.total.value;
        }

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_COMPANY_NOT_FOUND) {
          this.companies = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
